import Header from "../components/Header";
import Footer from "../components/Footer";

function ImpressumPage() {
  return (
    <>
      <Header />

      <main className="relative z-10 max-w-4xl mx-4 md:mx-auto pt-20 md:pt-24">
        <section className="glass-card p-6 md:p-10 text-left text-slate-800">
          <p className="uppercase tracking-[0.16em] text-xs font-bold text-cyan-700 mb-3">Rechtliches</p>
          <h1 className="text-3xl md:text-4xl font-black text-slate-900 mb-6">Impressum</h1>

          <div className="space-y-6 leading-relaxed">
            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Angaben gemaess § 5 TMG</h2>
              <p>Marko Piljak</p>
              <p>Softwareentwicklung und Prozessoptimierung</p>
              {/* <p>Strasse und Hausnummer: BITTE ERGAENZEN</p> */}
              {/* <p>PLZ Ort: BITTE ERGAENZEN</p> */}
              <p>E-Mail: markopiljak@web.de</p>
              <p>Telefon: +4915786549347</p>
            </div>

        

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Umsatzsteuer-ID</h2>
              <p>Falls vorhanden: USt-IdNr. gemaess § 27a UStG: BITTE ERGAENZEN</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Verantwortlich fuer den Inhalt nach § 18 Abs. 2 MStV</h2>
              <p>Marko Piljak</p>
              <p>Anschrift wie oben</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Haftung fuer Inhalte</h2>
              <p>
                Als Diensteanbieter sind wir gemaess § 7 Abs. 1 TMG fuer eigene Inhalte auf diesen Seiten nach den allgemeinen
                Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
                uebermittelte oder gespeicherte fremde Informationen zu ueberwachen oder nach Umstaenden zu forschen,
                die auf eine rechtswidrige Taetigkeit hinweisen.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Haftung fuer Links</h2>
              <p>
                Unser Angebot enthaelt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
                Deshalb koennen wir fuer diese fremden Inhalte auch keine Gewaehr uebernehmen.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Urheberrecht</h2>
              <p>
                Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
                Die Vervielfaeltigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der Grenzen des Urheberrechts
                beduerfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default ImpressumPage;
